<template>
  <div class="call">
    <div class="form-container" v-if="!activeCall && !activeRoomSession">
      <CallUserForm @call="onCall" @sms="onSms"/>
      <div class="error-msg" v-if="error">{{error}}</div>
      <div class="status" v-if="activeCall">{{activeCall.status}}</div>
    </div>
    <CallSession v-else-if="activeCall" :call="activeCall" />
    <VideoSession v-else-if="activeRoomSession" :room-session="activeRoomSession" />
  </div>
</template>

<script>
  import CallUserForm from '../components/forms/CallUserForm';
  import {mapState} from 'vuex';
  import CallSession from "../components/call/CallSession";
  import VideoSession from "../components/call/VideoSession";

  const CALL_STATUS = {
    initial: 'initial',
    calling: 'calling',
    ringing: 'ringing',
    answered: 'answered'
  };

  export default {
    components: {
      VideoSession,
      CallSession,
      CallUserForm
    },
    props: {
      callSid: {
        type: String,
        default: null
      },
      sessionId: {
        type: String,
        default: null
      }
    },
    data: () => ({
      CALL_STATUS,
      error: null
    }),
    computed: {
      ...mapState({
        activeCalls: state => state.call.activeCalls,
        activeVideoSessions: state => state.call.activeVideoSessions
      }),
      activeCall() {
        return this.activeCalls[this.callSid]
      },
      activeRoomSession() {
        return this.activeVideoSessions[this.sessionId]
      }
    },
    methods: {
      onCall(phone) {
        this.$store.dispatch('call/startCall', phone)
          .then(callSid => {
            this.$router.push({
              name: 'ActiveCall',
              params: {
                callSid
              }
            })
          })
          .catch(err => {
            this.error = err.message
          })
      },
      onSms(phone) {
        this.$store.dispatch('call/startVideoSession', phone)
          .then(({sessionId}) => {
            this.$router.push({
              name: 'ActiveVideoSession',
              params: {
                sessionId
              }
            })
          })
          .catch(err => {
            this.error = err.message
          })
      }
    },

  }
</script>

<style lang="scss">
@import "Call";
</style>
